import React from 'react';
import { SxProps, Theme } from '@mui/material/styles';
import { SectionCard } from './SectionCard';

interface TableCardProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Wraps a `Table` so every grid-backed tab gets a heading and the same card
 * frame as the field tabs. The data grid draws its own border, which would
 * double up against the card's, so it is dropped here.
 */
export function TableCard({ title, description, action, children, sx }: TableCardProps) {
  return (
    <SectionCard
      title={title}
      description={description}
      action={action}
      disablePadding
      sx={{ '& .MuiDataGrid-root': { border: 0 }, ...sx }}
    >
      {children}
    </SectionCard>
  );
}
